import { provideWidgetClass } from 'scrivito'

export const DXPOverviewWidget = provideWidgetClass('DXPOverviewWidget', {
  attributes: {},
})
